import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { formatRands, shortId } from "@/lib/order";
import { StaffShell } from "@/components/layout/StaffShell";
import { adminNav } from "@/lib/nav";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { StatusBadge } from "@/components/common/StatusViews";
import { CenterSpinner, EmptyState } from "@/components/common/States";

export default function AdminOrders() {
  const { data, isLoading } = useQuery({ queryKey: ["admin-orders"], queryFn: () => api("/admin/orders") });

  return (
    <StaffShell items={adminNav} roleLabel="Admin" title="Orders">
      {isLoading ? (
        <CenterSpinner />
      ) : !data?.length ? (
        <EmptyState title="No orders yet" />
      ) : (
        <Card className="overflow-hidden rounded-2xl">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Order</TableHead>
                <TableHead>Vendor</TableHead>
                <TableHead>Customer</TableHead>
                <TableHead>Total</TableHead>
                <TableHead>Status</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {data.map((o) => (
                <TableRow key={o.order_id} data-testid={`admin-order-row-${o.order_id}`}>
                  <TableCell className="font-medium">{shortId(o.order_id)}</TableCell>
                  <TableCell>{o.vendor_name}</TableCell>
                  <TableCell>{o.customer_name}</TableCell>
                  <TableCell>{formatRands(o.total)}</TableCell>
                  <TableCell><StatusBadge status={o.status} /></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Card>
      )}
    </StaffShell>
  );
}
